<template>
  <core-tooltip text="Font family">
    <div :style="inputWrapperStyle">
      <u-input-menu
        v-model="selectedFont"
        :options="fontOptions"
        :ui="{rounded: 'rounded-md'}"
        size="sm"
        option-attribute="label"
        value-attribute="value"
      >
        <template #option="{option}">
          <span class="text-xl" :style="option.css">{{option.label}}</span>
        </template>
      </u-input-menu>
    </div>
  </core-tooltip>
</template>

<script setup>
  import {storeToRefs} from 'pinia';

  const selectedFont = defineModel('selectedFont');
  const surfaceEditorStore = useSurfaceEditorStore();
  const {fonts} = storeToRefs(surfaceEditorStore);

  const googleFonts = useGoogleFonts();

  const parsedFonts = computed(() => fonts.value.reduce((map, font) => {
    map[font] = googleFonts.parseFontString(font);
    return map;
  }, {}));

  const fontOptions = computed(() => fonts.value.map(font => ({
    value: font,
    label: parsedFonts.value[font].displayName,
    css: parsedFonts.value[font].css
  })));

  const inputWrapperStyle = computed(() => {
    if (selectedFont.value && parsedFonts.value[selectedFont.value]) {
      return parsedFonts.value[selectedFont.value].css;
    }
    return {};
  });

</script>

<style scoped>
  /* Apply font styling to the input text */
  :deep(input) {
    font-family: inherit !important;
    @apply min-w-60;
  }
</style>
